export default "__VITE_ASSET__DlV$xluM__"